import { render, staticRenderFns } from "./AufgabenComponentEditAufgabe.vue?vue&type=template&id=10f1051d"
import script from "./AufgabenComponentEditAufgabe.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentEditAufgabe.vue?vue&type=script&lang=js"
import style0 from "./AufgabenComponentEditAufgabe.vue?vue&type=style&index=0&id=10f1051d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports